export const TOGGLE_DRAWER = 'TOGGLE_DRAWER'

export const toggleDrawer = value => ({type: TOGGLE_DRAWER, value})
